// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"228010e9","453":"c168d4f2"}[chunkId] + ".chunk.js";
};